import Movie from "./models/movie";
import Comment from "./models/comment";

const Method = {
  GET: `GET`,
  POST: `POST`,
  PUT: `PUT`,
  DELETE: `DELETE`
};

const Status = {
  SUCCESS: 200,
  REDIRECTION: 300
};

const checkStatus = (response) => {
  if (response.status >= Status.SUCCESS && response.status < Status.REDIRECTION) {
    return response;
  }
  throw new Error(`${response.status}: ${response.statusText}`);
};

export default class API {
  constructor(endPoint, authorization) {
    this._endPoint = endPoint;
    this._authorization = authorization;
  }

  getMovies() {
    return this._load({url: `movies`})
      .then((response) => response.json())
      .then(Movie.parseMovies);
  }

  updateMovie(id, movie) {
    return this._load({
      url: `movies/${id}`,
      method: Method.PUT,
      body: JSON.stringify(movie.toRAW()),
      headers: new Headers({"Content-Type": `application/json`})
    })
      .then((response) => response.json())
      .then(Movie.parseMovie);
  }

  getComments(movies) {
    const promises = movies.map((movie) => {
      return this._load({url: `comments/${movie.id}`})
        .then((response) => response.json())
        .then(Comment.parseComments);
    });

    return Promise.all(promises);
  }

  createComment(id, comment) {
    return this._load({
      url: `comments/${id}`,
      method: Method.POST,
      body: JSON.stringify(comment),
      headers: new Headers({"Content-Type": `application/json`})
    })
      .then((response) => response.json())
      .then((comments) => {
        const newMovie = Movie.parseMovie(comments[`movie`]);
        const newComments = Comment.parseComments(comments[`comments`]);
        return {newMovie, newComments};
      });
  }

  deleteComment(id) {
    return this._load({
      url: `comments/${id}`,
      method: Method.DELETE
    });
  }

    _load({url, method = Method.GET, body = null, headers = new Headers()}) {
        this._addAuthHeader(headers);

        return fetch(`${this._endPoint}/${url}`, {method, body, headers})
            .then(checkStatus);
    }

    _addAuthHeader(headers) {
        headers.append(`Authorization`, this._authorization);
    }
}
